// constants.js
// Centralized constants for the application

// API
export const BASE_SERVER_URL = process.env.REACT_APP_DEBUG_API_URL || "/api"

// Password rules
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 30

// Club info
export const CLUB_EMAIL = "breikkihallitus@gmail.com"
export const CLUB_INSTAGRAM_NAME = "akateeminenbreikki"
export const CLUB_INSTAGRAM_LINK_HREF = "https://www.instagram.com/akateeminenbreikki/"
export const CLUB_LINKTREE_LINK_HREF = "https://linktr.ee/breikki"
